import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DataConnectorType, FtpServerType, FtpService, ParquetDataConnector } from 'src/app/domainObjects/dataConnector';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { FileBrowserDialogComponent } from 'src/app/views/file-browser-dialog/file-browser-dialog.component';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { ConfigService } from 'src/app/services/config/config.service';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'src/app/services/shared.service';
import { UserDataService } from 'src/app/services/user-data-service';
// import { IngestParametersSetting, IngestParametersSettings } from 'src/app/domainObjects/masterConfig';
import { FolderBrowserDialogComponent } from 'src/app/views/folder-browser-dialog/folder-browser-dialog.component';
import { DatePipe } from '@angular/common';
import { UpdateingestnodestatusService } from 'src/app/services/updateingestnodestatus.service';
import { GetTotalPartitionedFoldersRequest } from 'src/app/messaging/getTotalPartitionedFoldersRequest';
import { ParquetpartitionFolderBrowserDialogComponent } from '../../parquetpartition-folder-browser-dialog/parquetpartition-folder-browser-dialog.component';
import { FtpConnectionStatus, ftpNotReadyMessage } from 'src/app/views/shared/ftp-service-select/ftp-service-select.component';

export class ParquetDataConnectorViewModel extends DataConnectorViewModel<ParquetDataConnector> {
  id: number;
  fileNameFormat = '';
  scheduleDelimiter='';
  connectionTimeOut: number;
  scheduleConnectionTimeOut='';
  inputFileNameFileScheduleDirectory='';
  baseFileName='';
  dateTimeExtension: string = '';  // Date-Time extension
  selectedInstance= '';
  nValue= '';
  currentDate: string;  // Holds the current date in YYYY-MM-DD format
  fileExtension='';
  isPartitionMode: boolean = false;
  partitionDirectory: string = '';
  totalPartitionedFolders: number;

  constructor(parquetDataConnector?: ParquetDataConnector) {
    super();
    this.dataConnectorType = DataConnectorType.Parquet;
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; // Extracts the date part in YYYY-MM-DD format

     // Set the defualt values
     this.scheduleConnectionTimeOut="180"
     this.scheduleDelimiter='';
     this.baseFileName='';
     this.dateTimeExtension = 'yyyy-MM-dd';  // Set the current date as default
     this.nValue='';
     this.fileExtension='.parquet';
     this.isUseFtp =false;
     this.ftpService = new FtpService(FtpServerType.SFTP,"","","", 22);
    if (parquetDataConnector) {
      this.inputFileName = parquetDataConnector.filePath;
      this.fileNameFormat = parquetDataConnector.fileNameFormat;
      this.id = parquetDataConnector.id;
      this.connectionTimeOut = parquetDataConnector.connectionTimeOut;
      this.selectedInstance = parquetDataConnector.selectedInstance;
      this.nValue = parquetDataConnector.nValue;
      this.inputFileNameFileScheduleDirectory=parquetDataConnector.inputFileNameFileScheduleDirectory;
      this.baseFileName=parquetDataConnector.baseFileName;
      this.isUseFtp = parquetDataConnector.isUseFtp;
      this.ftpService = parquetDataConnector.ftpService;
      this.isPartitionMode = parquetDataConnector.isPartitionMode ?? false;
      this.partitionDirectory = parquetDataConnector.partitionDirectory ?? '';
    }
  }

  toDataConnector(): ParquetDataConnector {
    return new ParquetDataConnector(this.id, this.inputFileName, this.fileNameFormat, this.connectionTimeOut,this.selectedInstance,this.nValue,this.inputFileNameFileScheduleDirectory,this.baseFileName,this.isUseFtp,this.ftpService,this.isPartitionMode,this.partitionDirectory);
  }
}
/**
 *ParquetDataConnector Component
 * Provides the UI and logic for configuring ParquetDataConnector Data Connectors.
 */
@Component({
    selector: 'app-parquet-data-connector',
    templateUrl: './parquet-data-connector.component.html',
    styleUrls: ['./parquet-data-connector.component.css'],
    standalone: false
})
export class ParquetDataConnectorComponent extends BaseComponent implements OnInit {
  @Input() dataSourceType: DataSourceType;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;
  //@Input() viewModel: FileDataConnectorViewModel;
  isLoading = new BehaviorSubject<boolean>(false);
  
  // myControl = new UntypedFormControl('');
  delimiterOptions: Observable<string[]>;
  formattedDate: string;
  selectedFormat: string = 'yyyy-MM-dd'; // Default format
  viewModel: ParquetDataConnectorViewModel;
  isInstanceDisabled:boolean;
  isDisplayTotalPartitionFolders:boolean=false;
  private subscription!: Subscription;
   
  constructor(
    private changeDet: ChangeDetectorRef, 
    private configService: ConfigService,
    private sharedService: SharedService,
    private userData: UserDataService,
    private updateingestnodestatusService: UpdateingestnodestatusService,
    matDialog: MatDialog,
    private snackBar: MatSnackBar,
    public datePipe: DatePipe,
    errorLogger: ErrorReportingService) {
   super(errorLogger, matDialog);
      this.isInstanceDisabled= false;
    }
    /**
   * Updates the formatted date based on the selected format.
   */
    updateDate() {
      const currentDate = new Date();
      this.formattedDate = this.datePipe.transform(currentDate, this.selectedFormat) || '';
    }
    /**
   * Handles changes in date format.
   * @param newFormat - The new date format selected.
   */
  onFormatChange(newFormat: string) {
  this.selectedFormat = newFormat;
  this.updateDate();
}
  ngOnInit(): void {
 
    this.updateDate();
    this.subscription = this.sharedService.getEvent().subscribe(data => {
      // console.log('Received event in Child One:', data);
      this.changeDet.detectChanges();
      // Handle the event data here
    });
    if(!this.viewModel.ftpService){
      this.viewModel.ftpService=new FtpService(FtpServerType.SFTP,"","","", 22);
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe(); // Clean up to avoid memory leaks
  }
  ngOnChanges(changes: any) {

    this.viewModel = changes.ingestConfigViewModel?.currentValue.getParquetDataConnector();
    if (!this.viewModel || this.viewModel.dataConnectorType!=DataConnectorType.Parquet) {
      this.viewModel = new ParquetDataConnectorViewModel();
      this.viewModel.ftpService=new FtpService(FtpServerType.SFTP,"","","", 22);
      this.viewModel.dataSourceType = this.dataSourceType;
      this.ingestConfigViewModel.dataConnector = this.viewModel;
    } else {

    }
  }

  /** Connection test state of the selected FTP service; FTP browsing waits for 'success'. */
  ftpConnectionStatus: FtpConnectionStatus = 'none';

  onFtpChange(updated: FtpService) {
    this.viewModel.ftpService = updated;
  }

  async handleBlur(value: string) {
    await this.getParquetFileExistCheck(value);
  }
  async getParquetFileExistCheck(filePath: string) {
    const busyDialog = this.showBusyDialog('Validating file name existence...');
    try {
      // Set the input file name
      this.viewModel.inputFileName = filePath;
  
      // Call the API and wait for the response
      const response = await this.configService.getParquetFileExistCheck(this.viewModel.inputFileName);
      if (response?.fileExistsStatus === false) {
        this.displayError("The file or file path of the Developer File Path was not found or incorrectly entered.", "File or File path not found");    
        this.viewModel.inputFileName = "";
        this.changeDet.detectChanges();
        return; // Exit early if file doesn't exist
      } 
      // If file exists, proceed with further logic (if any)
      // You can add your sheet name logic here
  
    } catch (err) {
      const errorMessage = err?.error || err?.message || '';
      const statusCode = err?.status;
  
      if (statusCode === 500 || errorMessage.includes('500 Internal Server Error')) {
        this.displayError("The file or file path of the Developer File Path was not found or incorrectly entered.", "File or File path not found");  
        this.viewModel.inputFileNameExcel = "";
        this.changeDet.detectChanges();
      } else {
        this.displayError('Failed to get Sheet Name', 'Error', err, (result) => {});
      }
  
      this.changeDet.detectChanges();
    } finally {
      busyDialog.close();
    }
  }
  /**
   * Opens the file browser dialog for selecting files.
   */
  showFileBrowserDialog(): void {
    const ftpNotReady = ftpNotReadyMessage(this.viewModel.isUseFtp, this.ftpConnectionStatus);
    if (ftpNotReady) {
      this.displayError(ftpNotReady, 'FTP Service');
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    dialogConfig.data = {dataSourceTypeId: this.dataSourceType, supportedFileTypes: ['.parquet'],isUseFtp:this.viewModel.isUseFtp,ftpService:this.viewModel.ftpService, ingestFilePath:this.viewModel.inputFileName, ingestDataConnectorType: this.viewModel.dataConnectorType};

    const dialogRef = this.matDialog.open(FileBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      //console.log('User selected to import file: ' + result.selectedFileName);
      const previousFileName = this.viewModel.inputFileName;
      this.viewModel.inputFileName = result.selectedFileName;

      // TODO: Determine why I need to invoke the below code to get UI reflecting the inputFileName
      this.changeDet.detectChanges();

      if (this.ingestConfigViewModel.hasMappedSourceChanged(previousFileName, result.selectedFileName)) {
        // The old Column Map refers to the previous file's columns — clear it and let the
        // Analyst know right away that it needs to be reconfigured.
        this.ingestConfigViewModel.columnMap = [];
      }
      if (this.ingestConfigViewModel.columnMap.length === 0) {
        this.displayWarning(
          'Please configure the Column Mapper before saving.',
          'Column Mapper Not Configured',
          null,
          () => {
            this.sharedService.sendEvent({ type: 'open_mapper_panel', guid: this.ingestConfigViewModel.guid });
          }
        );
        return;
      }
    });
  }
    /**
   * Opens the folder browser dialog for selecting directories.
   */
  browseDir(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    dialogConfig.data = {dataSourceTypeId: 1, supportedFileTypes: ['.parquet']};

    const dialogRef = this.matDialog.open(FolderBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      //console.log('User selected to import file: ' + result.selectedFileName);
      this.viewModel.inputFileNameFileScheduleDirectory= result.selectedFileName;
       // Focus back to the input field if necessary
     // Focus back to the input field if necessary

    //  this.formGroup[fieldname] = new FormControl(result.selectedFileName);
      //this.form = this.formBuilder.group(this.formGroup);
       // Ensure the input field regains focus
        this.changeDet.detectChanges();
    });
  }
 
  browsePartitionDir(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    dialogConfig.data = { dataSourceTypeId: 1, supportedFileTypes: ['.parquet'], ingestParquetPartitionFolderPath:this.viewModel.partitionDirectory };

    const dialogRef = this.matDialog.open(ParquetpartitionFolderBrowserDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }
      const previousPartitionDirectory = this.viewModel.partitionDirectory;
      this.viewModel.partitionDirectory = result.selectedFileName;
      if (this.viewModel.isPartitionMode) {
        this.invokeGetTotalPartitionedFolders(result.selectedFileName);
      }
      this.changeDet.detectChanges();

      if (this.ingestConfigViewModel.hasMappedSourceChanged(previousPartitionDirectory, result.selectedFileName)) {
        // The old Column Map refers to the previous partition's columns — clear it and let the
        // Analyst know right away that it needs to be reconfigured.
        this.ingestConfigViewModel.columnMap = [];
      }
      if (this.ingestConfigViewModel.columnMap.length === 0) {
        this.displayWarning(
          'Please configure the Column Mapper before saving.',
          'Column Mapper Not Configured',
          null,
          () => {
            this.sharedService.sendEvent({ type: 'open_mapper_panel', guid: this.ingestConfigViewModel.guid });
          }
        );
        return;
      }
    });
  }

  invokeGetTotalPartitionedFolders(filePath: string) {
    this.getTotalPartitionedFolders(filePath);
  }

  async getTotalPartitionedFolders(filePath: string): Promise<void> {
      const busyDialog = this.showBusyDialog('Getting Total Partitioned Folders...');
      try {
        const request = new GetTotalPartitionedFoldersRequest(filePath);
        const response = await this.configService.getTotalPartitionedFolders(request);
        const totalFolders = response.totalPartitionedFolders;
        this.viewModel.totalPartitionedFolders = totalFolders || 0;
        this.isDisplayTotalPartitionFolders = true;
        this.changeDet.detectChanges();
      }catch (err) {
        console.error('Total partitioned folders error:', err);
        //Extract errorType from backend error structure
        const errorType = err?.error?.errorMessage?.[0]?.exc_obj?.errorType;

        if (errorType === 'FileNotFoundError') {
          this.displayError("The file or file path of the Developer File Path was not found or incorrectly entered.", "File or File path not found");  
          this.viewModel.inputFileName='';
          this.changeDet.detectChanges();
        } else {
          this.displayError('Failed to get the total partitioned folders', 'Error', err, (result) => {});
        }
      }  finally {
        busyDialog.close();
      }
  }

  handleBlurDirectory(inputFileNameExcel: string) {
    setTimeout(() => {
      // Your logic to handle the blur event
      console.log('Directory:', inputFileNameExcel);
    }, 200);
  }

  onSelectionChange(selectedValue: string) {
      if (selectedValue === 'first') {
        this.viewModel.nValue = '1';
        this.isInstanceDisabled = true;  // Freeze the instance field
      } else if (selectedValue === 'nth') {
        this.viewModel.nValue = '1'; // Keep it blank for nth
        this.isInstanceDisabled = false;  // Freeze the instance field
      } else {
        this.viewModel.nValue = ''; // Keep it blank for nth
        this.isInstanceDisabled = true;  // Freeze the instance field
      }
    }
}
